import React from 'react'
import { Type, VideoBox } from '@/components/common'
import { Video } from '../types'

export interface Props {
  heading: string
  subheading?: string
  video?: Video
  className?: string
}

const Hero: React.FC<Props> = ({ heading, subheading, video, className }) => {
  return (
    <div className={className}>
      <div className="2xl:py-24 flex flex-col bg-gray-1 font-whitney text-white lg:flex-row lg:items-center lg:justify-around lg:py-12 xl:py-16">
        <div className="flex flex-col items-center justify-center p-6 text-center lg:text-left">
          <div>
            <Type
              as="h1"
              variant={[
                'heading-sm',
                'sm:heading-md',
                'lg:heading-lg',
                'xl:display',
              ]}
              className="mb-4 whitespace-pre-wrap lg:mb-6"
            >
              {heading}
            </Type>
            {subheading && (
              <Type
                as="h2"
                variant={['title-md', 'lg:heading-sm']}
                className="max-w-lg whitespace-pre-wrap text-gray-7"
              >
                {subheading}
              </Type>
            )}
          </div>
        </div>

        {video && (
          <div className="2xl:pr-0 w-full lg:w-[40%] lg:max-w-[700px] lg:pr-6">
            <VideoBox
              id={`videobox-${video.id}`}
              video={video.id}
              service={video.service}
              aspectRatio={video.aspectRatio}
              campaignSlug="apply"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Hero
